import { useEffect, useState } from "react";
import { CalendarClock } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";
import { useBookDemo } from "../context/BookDemoContext";

export function StickyBookDemo() {
  const { t, dir } = useLanguage();
  const { openDemo } = useBookDemo();
  const [visible, setVisible] = useState(false);
  const isRtl = dir === "rtl";

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 640);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const icon = <CalendarClock className="w-5 h-5 shrink-0" />;
  const label = (
    <span className={`max-w-0 group-hover:max-w-[10rem] ${isRtl ? "group-hover:mr-3.5" : "group-hover:ml-3.5"} overflow-hidden whitespace-nowrap transition-all duration-300 text-sm font-medium`}>
      {t.stickyCta.label}
    </span>
  );

  return (
    <button
      data-testid="sticky-book-demo-button"
      onClick={openDemo}
      aria-label={t.stickyCta.label}
      // Docked flush to the viewport edge as a rounded tab (not a floating circle) --
      // icon-only at rest, grows continuously outward from the pinned edge to reveal
      // the label on hover. direction:ltr is forced locally so child order below
      // (icon always nearest the dock edge) stays predictable regardless of page
      // language -- the dock side and rounding still flip per dir.
      style={{ direction: "ltr" }}
      className={`group hidden md:flex fixed top-1/2 -translate-y-1/2 z-40 items-center px-4 py-3.5 ${
        isRtl ? "left-0 rounded-r-full" : "right-0 rounded-l-full"
      } bg-[#111] dark:bg-white text-white dark:text-[#111] shadow-lg overflow-hidden transition-[opacity,transform] duration-300 ${
        visible ? "opacity-100 translate-x-0" : "opacity-0 pointer-events-none " + (isRtl ? "-translate-x-4" : "translate-x-4")
      }`}
    >
      {isRtl ? <>{icon}{label}</> : <>{label}{icon}</>}
    </button>
  );
}
